"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.schema = exports.schemaId = void 0;

var _models = require("@knxlab/models");

var _Exercice = _interopRequireWildcard(require("../Exercice"));

var _util = require("../../util");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var schemaId = "/TrainingSessionBlocExercice";
exports.schemaId = schemaId;
var schema = {
  id: schemaId,
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    title: {
      type: "string"
    },
    type: {
      type: "string",
      "enum": ["reps", "timer", "rest"]
    },
    reps: {
      type: "integer",
      minimum: 1
    },
    timer: {
      type: "integer",
      minimum: 1
    },
    exercice: {
      "$ref": _Exercice.schemaId
    },
    bloc: {
      type: "object",
      properties: {
        title: {
          type: "string"
        }
      }
    }
  }
};
exports.schema = schema;
var NAME = "BlocExercice";

var BlocExercice = /*#__PURE__*/function (_AbstractObject) {
  _inherits(BlocExercice, _AbstractObject);

  var _super = _createSuper(BlocExercice);

  function BlocExercice() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$rest = _ref.rest,
        rest = _ref$rest === void 0 ? false : _ref$rest;

    _classCallCheck(this, BlocExercice);

    _this = _super.call(this);

    if (rest) {
      _this.type = 'rest';
    } else {
      _this.reps = 1;
    }

    _this.timer = 10;
    return _this;
  }

  _createClass(BlocExercice, [{
    key: "getTitle",
    value: function getTitle() {
      if (this.type === 'rest') {
        return "Repos";
      }

      return this.title || this.exercice && this.exercice.getTitle() || "";
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      switch (this.type) {
        case 'reps':
          return "x" + this.reps;

        case 'timer':
          return (0, _util.renderTime)(this.timer);

        case 'rest':
          return (0, _util.renderTime)(this.timer);
      }

      return "";
    }
  }, {
    key: "getChecksum",
    value: function getChecksum() {
      var checksum = [];

      var _this$export = this["export"](),
          exercice = _this$export.exercice,
          exported = _objectWithoutProperties(_this$export, ["exercice"]);

      checksum.push("|blocExercice:" + JSON.stringify(exported) + "|");
      checksum.push(exercice && exercice.id);
      return checksum.join("_");
    }
  }, {
    key: "getExecutionTime",
    value: function getExecutionTime() {
      if (this.isRest() || this.type === 'timer') {
        return this.timer;
      }

      return this.reps * this.exercice.getExecutionTime();
    }
  }, {
    key: "isRest",
    value: function isRest() {
      return this.type === "rest";
    }
  }, {
    key: "getName",
    value: function getName() {
      return NAME;
    }
  }]);

  return BlocExercice;
}(_models.AbstractObject);

exports["default"] = BlocExercice;
BlocExercice.register({
  name: NAME,
  schema: schema,
  __class: BlocExercice
});